import { render, staticRenderFns } from "./facebookUpload.vue?vue&type=template&id=4f75b1e3&scoped=true"
import script from "./facebookUpload.vue?vue&type=script&lang=js"
export * from "./facebookUpload.vue?vue&type=script&lang=js"
import style0 from "./facebookUpload.vue?vue&type=style&index=0&id=4f75b1e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f75b1e3",
  null
  
)

export default component.exports